import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { LayoutProvider, useLayout } from './components/Layout/LayoutContext';
import { Header } from './components/Layout/Header';
import { Sidebar } from './components/Layout/Sidebar';
import { Dashboard } from './pages/Dashboard';
import { OnChainMonitor } from './pages/OnChainMonitor';
import { OffChainMonitor } from './pages/OffChainMonitor';
import { CompanyRevenue } from './pages/CompanyRevenue';
import { Treasury } from './pages/Treasury';
import { Logs } from './pages/Logs';

const AppContent: React.FC = () => {
  const { sidebarOpen } = useLayout();
  const [isLargeScreen, setIsLargeScreen] = React.useState(window.innerWidth >= 992);

  React.useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 992);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="app-wrapper">
      <Header />
      <Sidebar />
      <main
        className="app-main"
        style={{
          marginTop: '56px',
          padding: '1.5rem',
          transition: 'margin-left 0.3s ease',
          marginLeft: isLargeScreen && sidebarOpen ? '250px' : '0',
        }}
      >
        <div className="container-fluid">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/on-chain" element={<OnChainMonitor />} />
            <Route path="/off-chain" element={<OffChainMonitor />} />
            <Route path="/revenue" element={<CompanyRevenue />} />
            <Route path="/treasury" element={<Treasury />} />
            <Route path="/logs" element={<Logs />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <Router>
        <LayoutProvider>
          <AppContent />
        </LayoutProvider>
      </Router>
    </ErrorBoundary>
  );
};

export default App;